import React, { useState, useCallback, useEffect } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { usePericiandoService } from 'hooks/usePericiandoService'
import { TextField, Checkbox, CircularProgress } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectPericiando = (props) => {
  const periciandoService = usePericiandoService()
  const [periciandos, setPericiandos] = useState(null)
  const { periciandosExternos, setPericiandosExternos, setProcessandoImportarPericiando, label, idCaso } = props
  const [listaOpcoesPericiandosFiltros, setListaOpcoesPericiandosFiltros] = useState([])
  const [inputPericiando, setInputPericiando] = useState(null)

  const fetchPericiandos = useCallback(async () => {
    const exclude =  idCaso ? await periciandoService.listarPericiandosDeCasoAsync(idCaso, setProcessandoImportarPericiando) : []
    const response = await periciandoService.listarPericiandosAllAsync(setProcessandoImportarPericiando)
    const filteredResponse = response.filter((periciando) => !exclude.some((excluido) => excluido.id === periciando.id))
    setPericiandos(filteredResponse)
  }, [idCaso])

  useEffect(() => {
    fetchPericiandos()
  }, [fetchPericiandos])

  const handleChangeInputPericiando = useCallback(
    (value) => {
      setInputPericiando(value)
      if (periciandos) {
        if (value?.length > 2) {
          setListaOpcoesPericiandosFiltros((prevState) =>
            periciandos.filter((periciando) => {
              if (periciando.alcunha?.toUpperCase().includes(value?.toUpperCase()) || periciando.cpf?.toUpperCase().includes(value?.toUpperCase()) || periciando.nome?.toUpperCase().includes(value?.toUpperCase())) {
                return periciando
              }
            })
          )
        } else {
          setListaOpcoesPericiandosFiltros([])
        }
      }
    },
    [periciandos]
  )

  return (
    <AutocompleteNative
      value={periciandosExternos}
      multiple
      name="periciando"
      noOptionsText="Sem informações"
      disabled={periciandos === null || periciandos.length === 0}
      loading={periciandos === null}
      required
      options={listaOpcoesPericiandosFiltros || []}
      onChange={(event, newValue) => {
        setPericiandosExternos(newValue)
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `NOME: ${option.nome?.toUpperCase()} - ALCUNHA: ${option.alcunha ? option.alcunha.toUpperCase()  : 'Não informada'} - CPF: ${option.cpf ? option.cpf?.toUpperCase() : 'Não informado'}`}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{
              marginRight: 8,
            }}
            checked={selected}
          />
          {`NOME: ${option.nome?.toUpperCase()} - ALCUNHA: ${option.alcunha  ? option.alcunha.toUpperCase()  : 'Não informada'} - CPF: ${option.cpf ? option.cpf?.toUpperCase() : 'Não informado'}`}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          InputLabelProps={{
            shrink: true,
          }}
          value={inputPericiando}
          onChange={(e) => handleChangeInputPericiando(e.target.value)}
          onPaste={(e) => {
            const pastedText = e.clipboardData.getData('text')
            setInputPericiando(pastedText)
            handleChangeInputPericiando(pastedText)
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {periciandos === null && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          placeholder={periciandos === null ? 'Carregando...' : ''}
        />
      )}
    />
  )
}
